import {
  PaginatedPartOrderHistory,
  PartOrderHistoryInput,
} from '@snap-types/actions/part-order-history';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSiteUrl, param } from '@ui/store/api-builder/build-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

export const [getPartOrderHistory, useGetPartOrderHistoryQuery] = injectQuery<
  PartOrderHistoryInput,
  PaginatedPartOrderHistory
>(
  `${QUOTE_BUILDER_SLICE_NAME}/getPartOrderHistory`,
  ({ siteCode, partId, page, perPage, customerId }) => ({
    url: buildSiteUrl(siteCode, `part/${param(partId)}/order-history`),
    params: {
      page,
      perPage,
      customerId,
    },
  }),
);
